import { getCookie, setCookie, updateCookie, text_truncate } from '../core/utils.js';
import { trialButton } from './trial-buttons.js';

var code = '',
    ccode = '',
    leads_referrer = document.referrer;

export function setCampaignInfo() {
  var url_string = window.location.href; //window.location.href
  //console.log(url_string);
  var url = new URL(url_string);
  var gclid = url.searchParams.get("gclid") || getCookie("gclid") || '';
  var msclkid = url.searchParams.get("msclkid") || getCookie('msclkid') || '';
  var utmsource = url.searchParams.get("utm_source") || getCookie("utm_source") || '';
  var utmmedium = url.searchParams.get("utm_medium") || getCookie("utm_medium") || '';
  var utmcampaign = url.searchParams.get("utm_campaign") || getCookie("utm_campaign") || '';
  var utmterm = url.searchParams.get("utm_term") || getCookie("utm_term") || '';
  var matchtype = url.searchParams.get("matchtype") || getCookie("matchtype")  || '';
  var channel = url.searchParams.get("channel") || '';
  var journey = '';
  var gaid = getCookie('_ga');
  var campaign_info = '';
  var campaign_jn = '';
  var gclidmsclkid = '';
  var isBlog = false;
  var pageId = document.querySelector('#page_id').value ? document.querySelector('#page_id').value : '';
  var devicetype = "|(W)";
  var sleekr_journey = '';

  // variable untuk new waba format
  var waba_medium = getCookie("waba_code") || (typeof code !== 'undefined' ? code : '');
  var waba_campaign = getCookie("wabac_code") || (typeof ccode !== 'undefined' ? ccode : '');
  var last_medium = getCookie("last_medium_id") ? getCookie("last_medium_id") : '';
  var last_campaign  = getCookie("last_campaign_id") ? getCookie("last_campaign_id") : '';
  var last_gclid = getCookie("last_gclid") ? getCookie("last_gclid") : '';

  //TIMESTAMMP 
  var tt_date = new Date();
  var tt_month_base = tt_date.getMonth() + 1;
  var tt_month = (tt_month_base < 10 ? '0' : '').toString() + tt_month_base;
  var tt_day = (tt_date.getDate() < 10 ? '0' : '').toString() + tt_date.getDate();
  var tt_hour = (tt_date.getHours() < 10 ? '0' : '').toString() + tt_date.getHours();
  var tt_minutes = (tt_date.getMinutes() < 10 ? '0' : '').toString() + tt_date.getMinutes();
  var j_timestamp = tt_month.toString() + tt_day.toString() + tt_hour.toString() + tt_minutes.toString();
  

  //BANNER ID
  var today = new Date();
  var year = today.getFullYear().toString().slice(-2);
  var month = (today.getMonth() + 1).toString();
  if (month.length === 1) {
      month = "0" + month;
  }
  var formattedDate = year + month;

  if(waba_medium) {
    code = waba_medium;
  }

  if(waba_campaign) {
    ccode = waba_campaign;
  }

  if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent) ||
      /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0, 4))) {
    devicetype = '|(M)';
  } else {
    devicetype = '|(W)';
  }

  // function untuk format journey yg baru
  var resultsDate = tt_day.toString() + tt_month.toString() + tt_hour.toString() + tt_minutes.toString();

  var newUtmCamp = pageId.replace(/Blog/gm, '');
  var utermmatchtype;
  var getParamMatchtype = url.searchParams.get("matchtype") || '';
  var getParamUtmterm = url.searchParams.get("utm_term") || '';
  var getParamUtmsource = url.searchParams.get("utm_source") || '';
  var getParamUtmmedium = url.searchParams.get("utm_medium") || '';
  var getParamUtmcampaign = url.searchParams.get("utm_campaign") || '';

  if((getCookie('sr') != '' && getCookie('sr') != null && getCookie('sr') != undefined) && is_sr == "false") {
    if(getParamUtmterm == '') {
      getParamUtmterm = 'SR ' + getCookie('sr');
      setCookie('sr', '', 0);
    }
  }

  if (getParamUtmterm != '' || getParamMatchtype != '') {
    utermmatchtype = '.' + getParamMatchtype + '.' + getParamUtmterm;
  } else {
    utermmatchtype = '..';
  }
  
  if(last_medium != '' || last_campaign != '') {
    if(last_medium != waba_medium || last_campaign != waba_campaign) {
      updateCookie('last_medium_id', waba_medium);
      updateCookie('last_campaign_id', waba_campaign);
      var newJourney = newUtmCamp + '.' + resultsDate + '.' + waba_medium + waba_campaign + utermmatchtype;
    } else {
      if(getCookie('user_journey')) {
        var newJourney = newUtmCamp + '.' + resultsDate + '.' + utermmatchtype;
      } else {
        var newJourney = newUtmCamp + '.' + resultsDate + '.' + waba_medium + waba_campaign + utermmatchtype;
      }
    }
  } else {
    setCookie('last_medium_id', waba_medium, 31);
    setCookie('last_campaign_id', waba_campaign, 31);
    var newJourney = newUtmCamp + '.' + resultsDate + '.' + waba_medium + waba_campaign + utermmatchtype;
  }

  if(getCookie('devicetype')) {
    if(getCookie('banner_click')) {
      if(!getCookie('devicetype').includes(getCookie('banner_click'))) {
        devicetype = devicetype+getCookie('banner_click');
        updateCookie('devicetype', devicetype);
      } else {
        devicetype = devicetype+getCookie('banner_click');
      }
    } else {
      if(!getCookie('devicetype').includes(formattedDate)) {
        updateCookie('devicetype', devicetype);
      } else {
        devicetype = devicetype+formattedDate;
        updateCookie('devicetype', devicetype);
      }
    }
    
  } else {
    if(getCookie('created_at')) {
      updateCookie('devicetype', devicetype);
    } else {
      setCookie('devicetype', devicetype,31);
    }
  }


  // function ini untuk memasukkan format journey baru ke cookie journey
  if(getCookie('user_journey')) {
    journey = getCookie('user_journey');
    
    if(sleekr_journey != '') {
      journey = sleekr_journey+'|'+journey;
    }

    var last_pageId = /[^|]*$/.exec(journey)[0];

    if (!pageId.includes(last_pageId.split('.')[0])) {
      journey += '|' + newJourney + '.' + channel;
    } else {
      if(getParamUtmmedium != '' || getParamUtmcampaign != '' || getParamUtmterm != '' || getParamMatchtype != '' || channel != '') {
        if(getParamUtmmedium != getCookie('utm_medium') || getParamUtmcampaign != getCookie('utm_campaign') || getParamUtmterm != getCookie('utm_term') || getParamMatchtype != getCookie('matchtype') || channel != '') {
          journey += '|' + newJourney + '.' + channel;
        }
      } else {
        if (!pageId.includes(last_pageId.split('.')[0])) {
          if (!last_pageId.split('.')[2].includes(waba_medium)) {
            journey += '|' + newJourney + '.' + channel;
          }
        }
      }
    }

    if(getCookie('created_at')) {
      updateCookie('user_journey',journey);
    } else {
      setCookie('user_journey',journey, 31);
    }
  } else {
    if (sleekr_journey != '') {
      journey = sleekr_journey + '|' + newJourney + '.' + channel;
    } else {
      journey = newJourney + '.' + channel;
    }
    setCookie('user_journey',journey, 31);

    if(getCookie('created_at') == '' || getCookie('created_at' == null) ||  getCookie('created_at' == undefined)) {
      var dateCookie = new Date();
      dateCookie.setTime(dateCookie.getTime() + (31 * 24 * 60 * 60 * 1000));
      setCookie('created_at', dateCookie.toUTCString(), 31);
    }
  }

  if(last_gclid == '') {
    last_gclid = gclid ? gclid : '';
    setCookie('last_gclid', gclid, 90);
  } 

  // function ini untuk membuat gclid journey 
  var gclid_journey = getCookie('gclid_journey') ? getCookie('gclid_journey') : '';
  
  if(gclid_journey == '') {
    setCookie('gclid_journey', gclid, 90);
  } else {
    if(gclid != last_gclid) {
      gclid_journey = gclid_journey + '|' + gclid;
      updateCookie('gclid_journey', gclid_journey);
      updateCookie('last_gclid', gclid);
    }
  }

  // Seleksi semua elemen yang sesuai selector
  var elementsAddsOn = document.querySelectorAll('.item .item__wrap[data-name*="AO"]');
  if(elementsAddsOn.length > 0) {
    elementsAddsOn.forEach(function(element) {
      element.addEventListener('click', function() {
        setCookie('addons', '', 0); // Hapus cookie addons dulu
        var target = element.getAttribute('data-name');

        if (getCookie('addons')) {
          // Jika cookie addons sudah ada, update dengan menambahkan |target
          updateCookie('addons', '|' + target);
        } else {
          if (getCookie('created_at')) {
            // Jika cookie created_at ada, update cookie addons
            updateCookie('addons', '|' + target);
          } else {
            // Jika tidak ada cookie addons dan created_at, set cookie addons baru selama 31 hari
            setCookie('addons', '|' + target, 31);
          }
        }
      });
    });
  }
  var addons = getCookie('addons') || '';

  if(utmterm != '' && matchtype != '') {
    var uterm = '';
    uterm = ' @ '+matchtype+'|'+utmterm;
    setCookie('termmatchtype', uterm, 31);
  } else if(getCookie('termmatchtype')) {
    var uterm = '';
    uterm = getCookie('termmatchtype');
  } else {
    var uterm = '';
    if(getCookie('utm_term') && getCookie('matchtype')) {
      uterm = ' @ '+getCookie('matchtype')+'|'+getCookie('utm_term');
      setCookie('termmatchtype', uterm, 31);
    }
  }


  // ini untuk melimit journey baru
  var limit_journey = text_truncate(journey,240);

  if (gclid != '' || msclkid != '' || utmsource != '' || utmmedium != '' || utmcampaign != '') {

    gclidmsclkid = text_truncate(gclid+'|'+msclkid,250,'');

    var campaignInfo = JSON.parse('{"gclid":"' + gclidmsclkid + '", "utm_source":"' + utmsource + '", "utm_medium":"' + utmmedium + '", "utm_campaign":"'+limit_journey+devicetype+'"}');
    
    
    const stringifyCampaignInfo = JSON.stringify(campaignInfo)
    const cookiesCampaignInfo = encodeURIComponent(stringifyCampaignInfo)

    if(getCookie('created_at')) {
      updateCookie('campaign_info', cookiesCampaignInfo);
      updateCookie('gclid', gclid);
      updateCookie('msclkid', msclkid);
      updateCookie('utm_source', utmsource);
      updateCookie('utm_medium', utmmedium);
      updateCookie('utm_campaign', utmcampaign);
      updateCookie('utm_term', utmterm);
      updateCookie('matchtype', matchtype);
    } else {
      setCookie('campaign_info', cookiesCampaignInfo, 31);
      setCookie('gclid', gclid, 31);
      setCookie('msclkid', msclkid, 31);
      setCookie('utm_source', utmsource, 31);
      setCookie('utm_medium', utmmedium, 31);
      setCookie('utm_campaign', utmcampaign, 31);
      setCookie('utm_term', utmterm, 31);
      setCookie('matchtype', matchtype, 31);
    }

  } else {

    gclid = getCookie('gclid') || '';
    msclkid = getCookie('msclkid') || '';
    utmsource = getCookie('utm_source') || '';
    utmmedium = getCookie('utm_medium') || '';
    utmcampaign = getCookie('utm_campaign') || '';
    //var created_at = getCookie('created_at') || '';
    //console.log('2. created_at : '+created_at);

    if (gclid != '' || msclkid != '' || utmsource != '' || utmmedium != '' || utmcampaign != '') {
      gclidmsclkid = text_truncate(gclid+'|'+msclkid,250,'');
      var campaignInfo = JSON.parse('{"gclid":"' + gclidmsclkid + '", "utm_source":"' + utmsource + '", "utm_medium":"' + utmmedium + '", "utm_campaign":"' +limit_journey+devicetype+'"}');
      
      const stringifyCampaignInfo = JSON.stringify(campaignInfo)
      const cookiesCampaignInfo = encodeURIComponent(stringifyCampaignInfo)
      
      if(getCookie('created_at')) {
        updateCookie('campaign_info', cookiesCampaignInfo);
        updateCookie('gclid', gclid);
        updateCookie('msclkid', msclkid);
        updateCookie('utm_source', utmsource);
        updateCookie('utm_medium', utmmedium);
        updateCookie('utm_campaign', utmcampaign);
        updateCookie('utm_term', utmterm);
        updateCookie('matchtype', matchtype);
      } else {
        setCookie('campaign_info', cookiesCampaignInfo, 31);
        setCookie('gclid', gclid, 31);
        setCookie('msclkid', msclkid, 31);
        setCookie('utm_source', utmsource, 31);
        setCookie('utm_medium', utmmedium, 31);
        setCookie('utm_campaign', utmcampaign, 31);
        setCookie('utm_term', utmterm, 31);
        setCookie('matchtype', matchtype, 31);
      }
    } else {
      var campaignInfo = JSON.parse('{"gclid":"", "utm_source":"", "utm_medium":"", "utm_campaign":"'+limit_journey+devicetype+'"}');
      
      const stringifyCampaignInfo = JSON.stringify(campaignInfo)
      const cookiesCampaignInfo = encodeURIComponent(stringifyCampaignInfo)
      if(getCookie('created_at')) {
        updateCookie('campaign_info', cookiesCampaignInfo);
        updateCookie('gclid', '');
        updateCookie('msclkid', '');
        updateCookie('utm_source', '');
        updateCookie('utm_medium', '');
        updateCookie('utm_campaign', '');
        updateCookie('utm_term', '');
        updateCookie('matchtype', '');
      } else {
        setCookie('campaign_info', cookiesCampaignInfo, 31);
        setCookie('gclid', '', 0);
        setCookie('msclkid', '', 0);
        setCookie('utm_source', '', 0);
        setCookie('utm_medium', '', 0);
        setCookie('utm_campaign', '', 0);
        setCookie('utm_term', '', 0);
        setCookie('matchtype', '', 0);
      }
    }
  }

  if (gaid) {
    setCookie('gaid', '', 0);
    setCookie('gaid', gaid.slice(6), 31);
  } else {
    setCookie('gaid', '', 0);
  }

  trialButton();
}

export function initCampaign() {
  if ('requestIdleCallback' in window) {
    requestIdleCallback(setCampaignInfo, { timeout: 300 });
  } else {
    setTimeout(setCampaignInfo, 50);
  }
}